import { createRouter, createWebHashHistory, createMemoryHistory, type RouteMeta } from 'vue-router'
import { useLanguageStore, type Language } from '@/stores/settings/language'
import devRoutes from '@/router/dev-routes'
import introRoutes from '@/router/intro-routes'

declare module 'vue-router' {
  interface RouteMeta {
    next?: string // default next
  }
}

const history = import.meta.env.PROD
  ? createWebHashHistory(import.meta.env.BASE_URL) // Production createMemoryHistory()
  : createWebHashHistory(import.meta.env.BASE_URL) // Development createWebHashHistory()

const router = createRouter({
  history: history,
  routes: [
    {
      path: '/',
      redirect: import.meta.env.PROD ? 'th/intro/1' : '/th/intro/3',
    },

    ...devRoutes,
    ...introRoutes,
  ],
})

router.beforeEach((to, from, next) => {
  const languageStore = useLanguageStore()
  if (to) {
    if (to.params.lang) {
      languageStore.switchLanguage(to.params.lang as Language)
    }
  }
  next()
})

export default router
